(() => {
  const token = value => /^[A-Za-z0-9_.~-]{0,120}$/.test(value || '') ? value || '' : '';
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('form');
    if (!form) return;
    const status = root.querySelector('[role="status"]');
    const button = form.querySelector('button[type="submit"]');
    let requestId;
    let previousPayload;
    let busy = false;
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (root.dataset.ready !== 'true') { status.textContent = root.dataset.unavailable; return; }
      if (busy || !form.reportValidity()) return;
      const endpoint = root.dataset.endpoint;
      if (!/^\/apps\/[A-Za-z0-9/_-]+$/.test(endpoint || '') || !globalThis.crypto?.randomUUID) {
        status.textContent = root.dataset.unavailable;
        return;
      }
      const data = Object.fromEntries(new FormData(form).entries());
      data.marketing_consent = form.elements.marketing_consent.checked;
      data.consent_project_contact = form.elements.consent_project_contact.checked;
      const params = new URLSearchParams(location.search);
      data.attribution = Object.fromEntries(['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].map(k => [k, token(params.get(k))]));
      const fingerprint = JSON.stringify(data);
      if (previousPayload !== fingerprint) requestId = crypto.randomUUID();
      previousPayload = fingerprint;
      data.request_id = requestId;
      busy = true;
      button.disabled = true;
      form.setAttribute('aria-busy', 'true');
      status.textContent = root.dataset.sending;
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch(endpoint, {method: 'POST', headers: {'Content-Type': 'application/json'},
          body: JSON.stringify(data), credentials: 'omit', redirect: 'error', signal: controller.signal});
        if (response.status === 201) {
          const receipt = await response.json();
          if (!Number.isInteger(receipt.application_id) || receipt.application_id < 1) throw new Error('Invalid receipt');
          status.textContent = `${root.dataset.received} #${receipt.application_id}. ${root.dataset.emailPending}`;
          form.reset();
          requestId = undefined;
          previousPayload = undefined;
        } else if (response.status === 409) {
          status.textContent = root.dataset.duplicate;
        } else if (response.status === 422) {
          status.textContent = root.dataset.invalid;
        } else {
          status.textContent = root.dataset.unavailable;
        }
      } catch (_) {
        status.textContent = root.dataset.unavailable;
      } finally {
        clearTimeout(timeout);
        busy = false;
        button.disabled = false;
        form.removeAttribute('aria-busy');
      }
    });
  }
  document.querySelectorAll('[data-omega-pack]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-omega-pack]').forEach(init));
})();
